import { render, staticRenderFns } from "./InstagramSendMessage.vue?vue&type=template&id=ee0cfe4e"
import script from "./InstagramSendMessage.vue?vue&type=script&lang=js"
export * from "./InstagramSendMessage.vue?vue&type=script&lang=js"
import style0 from "./InstagramSendMessage.vue?vue&type=style&index=0&id=ee0cfe4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports